import {Button} from '@primer/react'
import {useRef, useState} from 'react'

import {ListItemRepoIcon} from './components/ListItemRepoIcon'
import {MultiSelectReposPickerDialog} from './MultiSelectReposPickerDialog'
import type {MultiSelectReposProps} from './types'

export function MultiSelectReposPicker(props: MultiSelectReposProps) {
  const [isDialogOpen, setDialogOpen] = useState(Boolean(props.isOpenInitially))
  const openDialogButtonRef = useRef<HTMLButtonElement>(null)

  const {selected} = props
  const count = selected?.length

  return (
    <>
      <Button
        ref={openDialogButtonRef}
        onClick={() => setDialogOpen(true)}
        leadingVisual={selected?.[0] ? <ListItemRepoIcon visibility={selected[0].visibility} /> : null}
        aria-describedby={props['aria-describedby']}
      >
        {count ? `${count} ${count > 1 ? 'repositories' : 'repository'} selected` : 'Select repositories'}
      </Button>
      {isDialogOpen && (
        <MultiSelectReposPickerDialog
          {...props}
          onDismiss={() => setDialogOpen(false)}
          returnFocusRef={openDialogButtonRef}
        />
      )}
    </>
  )
}

try{ MultiSelectReposPicker.displayName ||= 'MultiSelectReposPicker' } catch {}